<script setup lang="ts">
import { VALIDATOR_APY } from '~/config'

const validatorsStore = useValidatorsStore()
const apy = computed(() => validatorsStore.jstakingValidator?.apyTotal || VALIDATOR_APY)

const hwoToItems = computed(() => [
  {
    id: 1,
    title: 'Connect your Wallet',
    description: 'Connect your Solana wallet to get started with staking.',
  },
  {
    id: 2,
    title: 'Stake your<br/>SOL',
    description: 'Choose how much SOL you want to stake.',
  },
  {
    id: 3,
    title: 'Earn<br/>Yield',
    description: `Start earning yield in real time with ${apy.value.toFixed(2)}% APY.`,
  },
  {
    id: 4,
    title: 'Unstake at<br/>any Time',
    description: 'Need your SOL back? Just hit the Unstake button.',
  },
])
</script>

<template>
  <section id="second-section">
    <div class="section-title">
      <span>How to stake</span>
    </div>
    <div class="section-items">
      <div v-for="item in hwoToItems" :key="item.id" class="section-item">
        <span class="section-item__number">{{ item.id }}</span>
        <span class="section-item__title" v-html="item.title" />
        <span class="section-item__description">{{ item.description }}</span>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
#second-section {
  width: 100%;
  .section-title {
    font-size: 26px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 38px;

    @media (max-width: $breakpoint-md) {
      margin-bottom: 40px;
    }
  }

  .section-items {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;

    @media (max-width: $breakpoint-md) {
      grid-template-columns: 1fr 1fr;
    }

    @media (max-width: $breakpoint-xxs) {
      grid-template-columns: 1fr;
    }

    .section-item {
      border-radius: 18px;
      background-color: $gray-03;
      padding: $space-xxl;
      display: flex;
      flex-direction: column;
      gap: 12px;
      position: relative;

      @media (max-width: $breakpoint-xs) {
        padding: $space-md;
        gap: 4px;
      }

      &__number {
        font-size: 51.8px;
        font-weight: 600;
        line-height: 70px;
        color: $green;

        @media (max-width: $breakpoint-xs) {
          font-size: 34px;
        }
      }

      &__title {
        font-size: 24px;
        font-weight: 600;
        line-height: 30px;
        letter-spacing: 0.24px;

        @media (max-width: $breakpoint-xs) {
          font-size: 16px;
          line-height: 20px;
        }
      }

      &__description {
        font-size: 16px;
        font-weight: 500;
        line-height: 18px;
        letter-spacing: -0.16px;
        color: $gray-01;

        @media (max-width: $breakpoint-xs) {
          font-size: 12px;
          line-height: 24px;
        }
      }

      &:before {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 40px;
        height: 40px;
        content: '';
        display: block;
        background-image: url("data:image/svg+xml,%3Csvg width='39' height='39' viewBox='0 0 39 39' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.53553 8.53553C-1.61429 5.38571 0.616543 0 5.07107 0H34C36.7614 0 39 2.23858 39 5V33.9289C39 38.3835 33.6143 40.6143 30.4645 37.4645L1.53553 8.53553Z' fill='%2320B395'/%3E%3C/svg%3E%0A");
        background-repeat: no-repeat;
        background-size: contain;

        @media (max-width: $breakpoint-xs) {
          width: 30px;
          height: 30px;
          top: 12px;
          right: 12px;
        }
      }
    }
  }
}
</style>
